'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'carpool';
var width = 512;
var height = 512;
var aliases = ["car-people"];
var unicode = 'e69c';
var svgPathData = ['M0 416l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32L0 416zM116.8 224l118.4 0c-7.3-14.2-22.1-24-39.2-24l-40 0c-17.1 0-31.9 9.8-39.2 24zM136 144a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm140.8 80l118.4 0c-7.3-14.2-22.1-24-39.2-24l-40 0c-17.1 0-31.9 9.8-39.2 24zM296 144a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM416 416l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32-96 0z', 'M104.6 122.9L80.4 224l351.3 0L407.4 122.9c-6-25.2-28.6-42.9-54.5-42.9L159.1 80c-25.9 0-48.4 17.8-54.5 42.9zM28.4 234.8L57.9 111.7C69.2 65 111 32 159.1 32l193.9 0c48.1 0 89.9 33 101.1 79.7l29.5 123.1c17.1 11.5 28.4 31 28.4 53.2l0 128L0 416 0 288c0-22.2 11.3-41.7 28.4-53.2zM96 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarpool = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;